<template>
    <v-row justify="center">
        <v-col align="center" md="8">
            <div v-if="loading || this.bookings.length < 1">
            <Loading/>
            </div>
            <div v-if="!loading && this.bookings.length > 0">
                <QuoteBooking v-for="(booking, i) of bookings" :key="i" v-bind:booking="booking"/>
            </div>
        </v-col>
    </v-row>
  </template>
  
  <script>
  import QuoteBooking from '@/components/bookings/client/QuoteBooking';
  import Loading from '@/components/Loading';
  export default {
    name: 'Quotes',
    components: {
      QuoteBooking,
      Loading
    },
    data (){
        return{
            loading: false
        }
    },
    computed:{
        user() {
            return this.$store.getters['auth/getUser'];
        },
        bookings(){
            return this.$store.getters.getQuoteBookings;
        }
    },
    watch: {
        bookings(booking){
            if(booking.length < 1){
                this.loading = false;
                this.$router.push('/dashboard/create');
            }
            else{
                this.loading = false;
            }
        }
    },
    mounted(){
        if(this.bookings.length === 0){
            this.$store.dispatch('fetchClientBookings', this.user.id);
        }
    }
  }
  </script>
  
  <style scoped>
  
  </style>